import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentService } from './useCurrentService';

interface Params {
    allowanceId?: string;
}
export const useAllowancesGet = ({ allowanceId }: Params) => {
    const { id } = useCurrentService();

    const query = useRepositorySuspenseQuery('allowances', 'get', {
        allowanceProductId: allowanceId ?? '',
        serviceId: id,
    });

    return query.data;
};
